import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button, Table, Form } from 'react-bootstrap';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { resetPagination } from '../../../store/actions/commonActions';
import { fetchCostCenters, 
  filterCostCenters, 
  RESET_COST_CENTERS_PAGINATION, 
  SET_COST_CENTERS_PAGINATION } from '../../../store/actions/cost_centers/costCenterActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import PageTitle from '../../../common/PageTitle';
import ListPagination from '../../../common/ListPagination';

class CostCenters extends Component {

  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      this.props.fetchClients();
      this.props.resetPagination(RESET_COST_CENTERS_PAGINATION);
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  filterCostCenters = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Filter Cost Centers" onChange={(e) => {
        const filter = e.target.value;
        this.props.filterCostCenters(filter);
      }} />
    )
  }

  getFilteredCostCenters = (costCenters) => {
    if (!costCenters) {
      return null;
    }

    return costCenters.filter(costCenter => {
      const costCenterName = costCenter.cost_center_name || '';
      const costCenterCode = costCenter.cost_center_code || '';

      const costCenterData = [
        costCenterName,
        costCenterCode,
      ].join(" ").toLowerCase();
      
      const costCenterFilter = this.props.costCenters.costCenterFilter; 

      if (!costCenterFilter || costCenterData.includes(costCenterFilter.toLowerCase())) {
        return costCenter;
      }
      return null;
    })
  }

  renderCostCenters = () => {
    let costCenters = this.getFilteredCostCenters(this.props.costCenters.costCenters);
    
    if (costCenters) {
      //if the user tries to search and no matches the filter
      if (this.props.costCenters.costCenterFilter && !costCenters.length) {
        costCenters = null;
      }
      else {
        let min = this.props.costCenters.min;
        let max = this.props.costCenters.max;
        
        if (!this.props.costCenters.costCenterFilter) {
          costCenters = costCenters.slice(min - 1, max);
        }
      }
    } 
   
    let costCenterList = [];

    if (costCenters) {
      costCenterList = costCenters.length ? (
        costCenters.map((costCenter, key) => {
          return (
            <tr key={key}>
              <td>{costCenter.cost_center_code}</td>
              <td>{costCenter.cost_center_name}</td>
              <td>{costCenter.department.department_name}</td>
              <td className="align-right">
                <Button size="sm" className="btn-primary mr-3 btn-primary" onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/settings/costcenters/update?id=' + costCenter.id)
                }}>
                  <FontAwesomeIcon icon={faPen} /> Edit 
                </Button>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={4}>Loading....</td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={4}><p className="text-danger">No cost centers found.</p></td>
        </tr>
      )
    }

    return costCenterList;
  }

  render() {
    const addClient = <Button id="add-cost-center" size="sm" onClick={() => {
      this.props.history.push('/settings/costcenters/add')
    }}>Add Cost Center</Button>

    let listPagination = '';

    if (!this.props.costCenters.costCenterFilter) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination 
            dispatchType={SET_COST_CENTERS_PAGINATION}
            data={this.props.costCenters.clients} 
            min={this.props.costCenters.min}
            max={this.props.costCenters.max}
            currentPage={this.props.costCenters.currentPage} 
            totalPages={this.props.costCenters.totalPages} 
            fetchCallback="" 
            numItems={this.props.costCenters.numItems} />
        </div>
      )
    }
    return (
      <>
        <PageTitle pageName="Cost Center" actionButton={addClient} />
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead>
                <tr>
                  <th className="align-center">Code</th>
                  <th className="align-center">Name</th>
                  <th className="align-center">Department</th>
                  <th className="align-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    { this.filterCostCenters() }
                  </td>
                </tr>
                { this.renderCostCenters() }
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToDispatch = (state) => ({
  costCenters: state.costCenters 
})

const mapDispatchToProps = (dispatch) => ({
  fetchClients: () => dispatch(fetchCostCenters()),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  filterCostCenters: (...args) => dispatch(filterCostCenters(...args))
})

export default withRouter(connect(mapStateToDispatch, mapDispatchToProps)(CostCenters))
